import React from "react";
import "./index.css";

import MainMenu from "../MainMenu";

/* This is the Header of the website. It contains the logo, clan name and the navigation menu. */
const Header = () => {
  return (
    <div className="header">
      <div className="header-contents">
        <div className="header-brand">
          <img src="/site_assets/logo.png" alt="5th Marine Regiment" />
          <h1>5th Marine Regiment</h1>
        </div>
        <MainMenu />
      </div>
    </div>
  );
};

export default Header;
